import { post } from '@/utils/fetch'

import type { TContactSchema } from '@/views/contact/contact.schema'

type TContactResponse = {
  success: boolean
}

export const submitContactForm = async (data: TContactSchema) => {
  return post<TContactResponse>('/contact', data)
}
